<div class="main-container">
  <article class="about-ipaam">
    <div class="title">
      <h1>نگران چالش‌های خود نباشید،<br /><span>ایپــــام </span> را ارائه دهید!</h1>
      <p>
        شرکت دانش‌بنیان ایده پرداز دانش نوین آرشام (ایپام)، به ارائه خدمات و راه‌کارهای کم‌نظیر در حوزه فین‌تک می‌پردازد. این شرکت می‌کوشد تا با
        استفاده از فناوری‌های نوین و مبتکرانه، متخصصین توانمند این حوزه و زیرساخت‌های فنی منحصربه‌فرد، صنعت بزرگ فین‌تک را در ایران هم‌سطح با
        پیشرفت‌های جهانی ارتقا دهد .
      </p>
      <app-main-button routerLink="/solutions/exclusive">بیشتر بخوانید</app-main-button>
    </div>
    <div class="banner">
      <img src="assets/about-ipaam-banner.png" />
    </div>
  </article>
  <article class="brands-section">
    <div class="title">
      <h2>برند‌های ایپــــام</h2>
    </div>
    <div class="brands-cards">
      <div class="brand" routerLink="/brands/pardakhtyari">
        <div class="line" style="background: #0070bc; box-shadow: 0 -19px 25px 1px #0070bc7d"></div>
        <div class="item">
          <div class="logo">
            <img src="assets/Yari.svg" height="60" />
          </div>
          <div class="topic">
            <h4>پرداخت‌یاری</h4>
          </div>
          <p>
            ارائه خدمـــــــات <br />
            پرداخــــــت آنـــــلاین
          </p>
        </div>
      </div>
      <!--      <div class="brand" routerLink="/brands/pardakhtsazi">-->
      <!--        <div class="line" style="background: #642424; box-shadow: 0 -19px 25px 1px #64242491"></div>-->
      <!--        <div class="item">-->
      <!--          <div class="logo">-->
      <!--            <img src="assets/pardakhtsazi.png" height="45" />-->
      <!--          </div>-->
      <!--          <div class="topic">-->
      <!--            <h4>پرداخت‌سازی</h4>-->
      <!--          </div>-->
      <!--          <p>ارائه خدمات مالی نوین بر بستر بانکداری باز</p>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="brand" routerLink="/brands/pardakhtbani">-->
      <!--        <div class="line" style="background: #50d1dd; box-shadow: 0 -19px 25px 1px #50d1dda3"></div>-->
      <!--        <div class="item">-->
      <!--          <div class="logo">-->
      <!--            <img src="assets/Pardakhtbani.png" height="55" />-->
      <!--          </div>-->
      <!--          <div class="topic">-->
      <!--            <h4>پرداخت‌بانی</h4>-->
      <!--          </div>-->
      <!--          <p>ارائه خدمات مبتنی بر کیف پول الکترونیک</p>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="brand" routerLink="/brands/tobank">-->
      <!--        <div class="line" style="background: #ed2027; box-shadow: 0 -19px 25px 1px #ed2027"></div>-->
      <!--        <div class="item">-->
      <!--          <div class="logo">-->
      <!--            <img src="assets/tobank-logo.svg" height="28" />-->
      <!--          </div>-->
      <!--          <div class="topic">-->
      <!--            <h4>اپلیکیشن‌های پرداخت</h4>-->
      <!--          </div>-->
      <!--          <p>ارائه خدمات و توسعه پلتفرم‌های پرداخت</p>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="brand" routerLink="/brands/hotelsys">
        <div class="line" style="background: #8224e3; box-shadow: 0 -19px 25px 1px #8224e3ab"></div>
        <div class="item">
          <div class="logo">
            <img src="assets/HotelSys.svg" height="55" />
          </div>
          <div class="topic">
            <h4>هتل‌سیس</h4>
          </div>
          <p>GRM پیاده‌سازی مفهوم برای اولین بار در ایران</p>
        </div>
      </div>
    </div>
  </article>
  <article class="technology">
    <div class="container">
      <div class="logos">
        <div class="item">
          <img src="assets/react-logo.png" />
        </div>
        <div class="item">
          <img src="assets/laravel-logo.png" />
        </div>
        <div class="item">
          <img src="assets/python-logo.png" />
        </div>
        <div class="item">
          <img src="assets/node.js_logo.png" />
        </div>
        <div class="item">
          <img src="assets/adobe-corporate-logo.png" />
        </div>
        <div class="item">
          <img src="assets/mongoDB-logo.png" />
        </div>
        <div class="item">
          <img src="assets/google-flutter-logo.png" />
        </div>
        <div class="item">
          <img src="assets/angular-logo.png" />
        </div>
      </div>
      <div class="title">
        <h2>فناوری‌های ایپام</h2>
        <p>
          ایپام با استفاده از بهترین فناوری‌های نوین همگام با استانداردهای روز دنیا، اقدام به تولید و توسعه زیرساخت‌های فنی محصولات و خدمات مورد نظر
          مشتریان می‌کند.
        </p>
      </div>
    </div>
  </article>

  <article class="solutions">
    <div class="title">
            <h2>راه‌کارهای ایپام</h2>
            <ul>
              <li>ارائه مشاوره راه‌کارهای مبتنی بر کیف پول</li>
            <li>ارائه مشاوره و راه‌کارهای مورد نیاز برای اخذ مجوز پرداخت‌یاری</li>
              <li>ارائه مشاوره و راه‌کارهای مبتنی بر فناوران مالی با اخذ تاییده از شاپرک</li>
              <li>ارائه مشاوره و راه‌کارهای مبتنی بر WealthTech</li>
              <li>ارائه مشاوره و راه‌کارهای مبتنی بر تحلیل داده – BI</li>
              <li>ارائه مشاوره و راه‌کارهای بانکی</li>
            </ul>
            <app-main-button routerLink="/solutions/financial">بیشتر بخوانید</app-main-button>
    </div>
    <div class="banner">
      <img src="assets/Idea.png" />
    </div>
  </article>
  <article class="join-us">
    <div class="banner">
      <img src="assets/Join.png" />
    </div>
    <div class="title">
      <h2>به ایپام بپیوندید!</h2>
      <p>ما پیشرو حوزه فعالیت خود هستیم و محصولاتی می‌سازیم که زندگی مردم را بهبود می‌بخشد. می‌خواهید کارمند ایپام شوید؟ جایگاه خود را پیدا کنید.</p>
      <app-main-button routerLink="/job-offer">مشاهده فرصت‌های شغلی</app-main-button>
    </div>
  </article>
</div>
